import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { setCurrentTabAsDirty, tabLinesAddLine, tabLinesFieldChange, tabLinesRemoveLine, tabLinesSetExcessApplicable, tabLinesSetUnderCondition } from '../../../../store/details/svs/actions';

import { BelfiusCurrencyInput } from '../../../custom/belfius-currency-input';
import DaccaImportButton from '../../../custom/dacca-import-button';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { ReportTypeTC } from '../../../../business/models/typecode.enums';
import { SvsDTOLine as SvsLine } from '../../../../business/models/dto/svs/svs.dto';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { getTypeCodeTranslation } from '../../../../store/utils/typecodes/typecode-translations';
import styles from './svs.module.css';
import { TypeCodeTranslation } from '../../../../business/models/shared.model';
import { Role } from '../../../../store/shared/model';

interface PropsFromState {
    readonly currentLine: SvsLine;
    readonly lines: SvsLine[];
    readonly total: number | '';
    readonly totalForDisplay: string;
    readonly excessApplicableTC: string | undefined;
    readonly underConditionTC: string | undefined;
    readonly SVSSubjectToTC: TypeCodeTranslation[];
    readonly SVSApplicationOfTheExemptionTC: TypeCodeTranslation[];
    readonly damageRowExcessApplicableIsValid: boolean;
    readonly damageRowUnderConditionIsValid: boolean;
    readonly locked: boolean;
    readonly currentLanguage: string;
    readonly id: number;
}

interface PropsFromDispatch {
    readonly tabLinesFieldChange: typeof tabLinesFieldChange;
    readonly tabLinesAddLine: typeof tabLinesAddLine;
    readonly tabLinesRemoveLine: typeof tabLinesRemoveLine;
    readonly tabLinesSetExcessApplicable: typeof tabLinesSetExcessApplicable;
    readonly tabLinesSetUnderCondition: typeof tabLinesSetUnderCondition;
    readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SvsLines extends React.Component<AllProps> {
    private localization: Ii18n;

    constructor(props: AllProps) {
        super(props);
        this.localization = getI18n();
    }

    render() {
        const inputLineRow = (
            <div className={styles.row}>
                <div className={`${styles.column6x} ${styles.border}`}>
                    <input className={styles.input}
                        disabled={this.props.locked}
                        placeholder={this.localization.get('details.svs.svsLines.description')}
                        value={this.props.currentLine.description}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            this.props.setCurrentTabAsDirty();
                            this.props.tabLinesFieldChange({ ...this.props.currentLine, description: event.target.value });
                        }} />
                </div>
                <div className={`${styles.column} ${styles.border}`}>
                    <BelfiusCurrencyInput className={styles.input}
                        disabled={this.props.locked}
                        placeholder={this.localization.get('details.svs.svsLines.amount')}
                        value={this.props.currentLine.amount === 0 ? '' : this.props.currentLine.amount.toString()}
                        onChange={(value: string) => {
                            this.props.setCurrentTabAsDirty();
                        }}
                        onValueChange={(values: { value: string }) => {
                            this.props.tabLinesFieldChange({ ...this.props.currentLine, amount: Number(values.value) });
                        }}
                    />
                </div>
                <div className={`${styles.columnAddbutton} ${styles.border}`}>
                    <div className={styles.border}>
                        <div className={styles.addbutton}>
                            <img alt="" className={styles.lineImage} src={require('../../../../assets/images/add_85x85.png')} onClick={() => {
                                if (!this.props.locked) {
                                    this.props.tabLinesAddLine();
                                }
                            }} />
                        </div>
                    </div>
                </div>
            </div>
        );

        const linesRow = this.props.lines.filter((line) => !line.deleted).map(line => {
            return (
                <div key={line.sequence} className={styles.row}>
                    <div className={`${styles.column6x} ${styles.borderFirstColumn}`}>
                        <input className={`${styles.input} ${styles.font12px}`}
                            disabled={true}
                            value={line.description} />
                    </div>
                    <div className={`${styles.column} ${styles.borderSecondColumn}`}>
                        <BelfiusCurrencyInput className={styles.input} style={{ textAlign: 'right' }}
                            disabled={true}
                            value={line.amount !== 0 ? `€ ${line.amount.toString()}` : ''}
                        />
                    </div>
                    <div className={`${styles.columnAddbutton} ${styles.border}`}>
                        <div className={styles.border}>
                            <div className={styles.addbutton}>
                                <img alt="" className={styles.lineImage} src={require('../../../../assets/images/remove_85x85.png')} onClick={() => {
                                    if (!this.props.locked) {
                                        this.props.setCurrentTabAsDirty();
                                        this.props.tabLinesRemoveLine(line.sequence);
                                    }
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        );

        const linesTotalRow = (
            <div className={styles.row}>
                <div className={`${styles.column6x} ${styles.borderFirstColumn}`}>
                    <input className={styles.input}
                        disabled={true}
                        value={''} />
                </div>
                <div className={`${styles.column} ${styles.borderOnlyUpAndDown}`}>
                    <BelfiusCurrencyInput className={styles.input} style={{ textAlign: 'right' }}
                        disabled={true}
                        value={`${this.localization.get('details.svs.svsLines.total')}  ${this.props.totalForDisplay}`}
                    />
                </div>
                <div className={`${styles.columnAddbutton} ${styles.borderWithoutLeft}`}>
                    <div className={styles.fakebutton}>
                    </div>
                </div>
            </div>
        );

        const radioRowsExcessApplicable = (
            <div className={`${styles.row} ${styles.border}`}>
                {!this.props.damageRowExcessApplicableIsValid &&
                    <div className={styles.columnForRowValidation}>
                        <div className={styles.svsRowNotValid} ></div>
                    </div>
                }
                <div className={styles.columnMaxWidth}>
                    <RadioGroup
                        aria-label='Excess Applicable'
                        name='excessApplicable'
                        value={this.props.excessApplicableTC}
                        className={styles.radio}
                        style={{ flexDirection: 'column' }}
                        onChange={(event: React.ChangeEvent, value: string) => {
                            if (!this.props.locked) {
                                this.props.setCurrentTabAsDirty();
                                this.props.tabLinesSetExcessApplicable(value);
                            }
                        }}
                    >
                        <FormControlLabel
                            value='ToVaDeVrEnEvOnVeOvDePo'
                            control={<Radio />}
                            label={getTypeCodeTranslation(this.props.SVSSubjectToTC, this.props.currentLanguage, 'ToVaDeVrEnEvOnVeOvDePo')} />
                        <FormControlLabel
                            value='ToVaDeVrOvDePo'
                            control={<Radio />}
                            label={getTypeCodeTranslation(this.props.SVSSubjectToTC, this.props.currentLanguage, 'ToVaDeVrOvDePo')} />
                    </RadioGroup>
                </div>
            </div>
        );

        const radioRowsUnderCondition = (
            <div className={`${styles.row} ${styles.border}`}>
                {!this.props.damageRowUnderConditionIsValid &&
                    <div className={styles.columnForRowValidation}>
                        <div className={styles.svsRowNotValid} ></div>
                    </div>
                }
                <div className={styles.columnMaxWidth}>
                    <RadioGroup
                        aria-label='Under Condition'
                        name='underCondition'
                        value={this.props.underConditionTC}
                        className={styles.radio}
                        style={{ flexDirection: 'column' }}
                        onChange={(event: React.ChangeEvent, value: string) => {
                            if (!this.props.locked) {
                                this.props.setCurrentTabAsDirty();
                                this.props.tabLinesSetUnderCondition(value);
                            }
                        }}
                    >
                        <FormControlLabel
                            value='OnVoVaErVaAaEnDeBiDePo'
                            control={<Radio />}
                            label={getTypeCodeTranslation(this.props.SVSApplicationOfTheExemptionTC, this.props.currentLanguage, 'OnVoVaErVaAaEnDeBiDePo')} />
                        <FormControlLabel
                            value='OnVoVaDeBiDePoEnAaDoDeMa'
                            control={<Radio />}
                            label={getTypeCodeTranslation(this.props.SVSApplicationOfTheExemptionTC, this.props.currentLanguage, 'OnVoVaDeBiDePoEnAaDoDeMa')} />
                    </RadioGroup>
                </div>
            </div>
        );

        const daccaImportButton = (
            <DaccaImportButton
                {...this.props}
                reportType={ReportTypeTC.Svs}
                reference={this.props.id}
            />
        );

        return (
            <div className={styles.contentWrapper}>
                <div className={styles.svsLinesContent}>
                    {inputLineRow}
                    {linesRow}
                    {linesTotalRow}
                    {radioRowsExcessApplicable}
                    {radioRowsUnderCondition}
                </div>
                <div className={styles.daccaButtonContent}>
                    {daccaImportButton}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ details: { detailsSvs }, shared, caseState: { selectedCase } }: ApplicationState): PropsFromState => ({
    currentLine: detailsSvs.currentLine,
    lines: detailsSvs.lines,
    total: detailsSvs.lineAmountTotal,
    totalForDisplay: `€ ${detailsSvs.lineAmountTotal}`,
    excessApplicableTC: detailsSvs.excessApplicableTC,
    underConditionTC: detailsSvs.underConditionTC,
    SVSSubjectToTC: detailsSvs.SVSSubjectToTC,
    SVSApplicationOfTheExemptionTC: detailsSvs.SVSApplicationOfTheExemptionTC,
    damageRowExcessApplicableIsValid: detailsSvs.damageRowExcessApplicableIsValid,
    damageRowUnderConditionIsValid: detailsSvs.damageRowUnderConditionIsValid,
    locked: detailsSvs.locked || selectedCase.blocked || !shared.roles.includes(Role.ExFiLoAd),
    currentLanguage: shared.currentLanguage,
    id: detailsSvs.id
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    tabLinesFieldChange: (data: SvsLine) => dispatch(tabLinesFieldChange(data)),
    tabLinesAddLine: () => dispatch(tabLinesAddLine()),
    tabLinesRemoveLine: (sequence: number) => dispatch(tabLinesRemoveLine(sequence)),
    tabLinesSetExcessApplicable: (value: string | undefined) => dispatch(tabLinesSetExcessApplicable(value)),
    tabLinesSetUnderCondition: (value: string | undefined) => dispatch(tabLinesSetUnderCondition(value)),
    setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty())
});

export default connect(mapStateToProps, mapDispatchToProps)(SvsLines);
